import { Tag } from "../generic/Core"
import useTranslation from "../../hooks/useTranslation"
import useLocale from "../../hooks/useLocale"
import { retrieveParams } from "./widgets/retrieveParams"

const Warning = ({ warning, state, compareValue }) => {
    const { m } = useTranslation()
    const { lf } = useLocale()

    // `field` names the state key this warning watches. It used to be called
    // `condition`, which it never was — nothing here evaluates a predicate, it
    // reads one value. `meta.warning` already used `field` for the same idea.
    if (!warning || !warning.field || !(warning.field in state)) {
        return null
    }

    // Warn when the watched value has drifted from what the caller expects
    const isWarning = compareValue !== state[warning.field]
    const warningParams = warning.mergeParams ? retrieveParams(warning.mergeParams, state, lf) : []

    if (!isWarning) {
        return null
    }

    return (
        <>
            <Tag 
                $variant={warning.tagVariant} 
                $margin='0 0 0.5rem 0'
            >
                {m(warning.tagLabel)}
            </Tag>
            <span style={{ marginLeft: '0.5rem' }}>
                {m(warning.message, [lf(compareValue, 2, 2), ...warningParams])}
            </span>
        </>
    )
}

export default Warning
